import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { tg } from "./webapp";
import { haptic } from "./haptics";

const ROOT_PATHS = new Set(["/", "/browse"]);

/**
 * Binds Telegram's native back button to router history.
 *
 * Telegram already draws a back button in its own header; drawing a second one
 * in ours would be the clearest possible sign this is a website in a frame.
 */
export function useBackButton(): void {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const app = tg;
    if (!app) return;
    const atRoot = ROOT_PATHS.has(location.pathname);

    const onClick = () => {
      haptic.tap();
      navigate(-1);
    };

    if (atRoot) {
      app.BackButton.hide();
      return;
    }

    app.BackButton.onClick(onClick);
    app.BackButton.show();
    return () => {
      app.BackButton.offClick(onClick);
      app.BackButton.hide();
    };
  }, [location.pathname, navigate]);
}
